import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components'

const CssBaseline = styled.span`
    nav-link {
        font-weight: 400;
    }
`;


const NavLink = (props) => {

    if (process.env.REACT_APP_DOCUMENTATION_MODE === props.mode || props.mode === "public")
    {
        return (
                <CssBaseline>
                    <Link {...props} className="nav-link" />
                </CssBaseline>
            );
    }
    else
    {
        return null;
    }
}

export default NavLink;


// WEBPACK FOOTER //
// ./src/components/NavLink.js